import {uiMsg} from '../utils/Languages';
import React, {Component} from 'react';
import {observer} from 'mobx-react';
import AppModel from '../DataModel/AppModel';
import AppModelUtils from '../DataModel/AppModelUtils';
import TextField from 'material-ui/TextField';
import Dialog from 'material-ui/Dialog';
import Checkbox from 'material-ui/Checkbox';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import Paper from 'material-ui/Paper';
import CircularProgress from 'material-ui/CircularProgress';

import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';

import {Toolbar, ToolbarGroup, ToolbarSeparator, ToolbarTitle} from 'material-ui/Toolbar';

import PageLoading from '../components/PageLoading';
import SelectParentLocation from '../components/SelectParentLocation';
import SelectRoomType from '../components/SelectRoomType';
import SelectDefaultJobType from '../components/SelectDefaultJobType';

import RegisterBeacon from '../components/RegisterBeacon';
import Location from '../DataModel/Location';
import MachineList from '../components/MachineList';

const formStyle = {
  margin: 24
};

const errorStyle= {
  color: "red",
  margin: "0.5rem 0"
}

export default
@observer class NewRoomPage extends Component {

  static contextTypes = {
    router: React.PropTypes.object
  }

  constructor(props) {
    super(props);
    this.state = {
      uniqueName: false,
      multiple: false,
      report: true,
      openDialog: false,
      csvResult: null,
      csv: "",
      csvData: []
    };
  }
  handleClose = () => {
    this.setState({
      openDialog: false,
      csv: "",
      csvResult: null,
      csvData: []
    });
  };

  
  // Helper method that writes values back to datamodel as fields are changed
  handleValue(event) {
    var field = event.target.dataset.propname;
    var value = event.target.value;
    console.log("handleValue called");
    if(value=="") value = null;
    AppModel.newRoomForm.location[field]=value;
  }

  toggleCheck = (event, check) => {
    this.setState({ [check]: event.target.checked })
  }
  uniqueName(location){
    const rooms = AppModel.allRooms().filter(r => !location.id_parent || location.id_parent === "root" ? !r.id_parent : location.id_parent === r.id_parent).map(room => room.name);
    if(!this.state.multiple) this.setState({ uniqueName: rooms.indexOf(location.name) === -1 })
    return rooms.indexOf(location.name) === -1;
  }
  isValid(location, namesList){
    const availableJobTypes = AppModel.availableJobTypes.map(job => job.id);
    let errors = []
    const uniqueName = this.uniqueName(location);
    const roomSize = location.checkIfValid();
    const correctJob = availableJobTypes.indexOf(location.default_job_type) !== -1 || location.default_job_type === null;
    var cnt = this.count(namesList, location.name); 
    const duplicateInCsv = cnt > 1;
    if(cnt > 1) {
      errors.push(uiMsg('NR_ERROR_EXISTING_ROOM_CSV', "Duplicate room name in CSV"))
    }
    if(!uniqueName){
      errors.push(uiMsg('NR_ERROR_EXISTING_ROOM', "Existing room name"))
    }
    if(!roomSize){
      errors.push(uiMsg('NR_ERROR_ROOM_SIZE', "Room dimensions are incorrect"))
    }
    if(!correctJob){
      errors.push(uiMsg('NR_ERROR_WRONG_JOB_TYPE', "Job type is not available"))
    }
    return { isValid: uniqueName && roomSize && correctJob && !duplicateInCsv, errorMessages: errors }
  }
  count(arr, query) {
    var count = 0;
    for(let i=0; i<arr.length; i++)
        if (arr[i]==query)
            count++;
    return count;
  }
  namesCSV(csv) {
    let namesInCSV = csv.split("\n");
    var nameArray = [];   
    for (var i = 0; i < namesInCSV.length; i++) {
      const name = namesInCSV[i].split(",")[0];
      nameArray.push(name);
    }
    return nameArray;
  }
  handleCSV = (event) => {
    let value = event.target.value;
    this.handleCSVChange(value);
  }
  handleCSVChange = (value) => {
    this.setState({ csv: value })
    if(value === "") {
      this.setState({ csvData: [] })
      return
    }
    const defaultCustomerJobType = AppModel.availableJobTypes.length > 0 ? AppModel.availableJobTypes.sort((a, b) => a.priority - b.priority)[0].id : null;
    let namesList = this.namesCSV(value);
    value = value.split("\n");
    value = value.map((line, i) => {
      const p = line.split(",");
      let [name, height, length, width, beacon, jobType] = p;
      height = parseFloat(height);
      length = parseFloat(length);
      width = parseFloat(width);
      const location = new Location();
      location.name = name;
      location.id_type = 'R';
      location.height = height;
      location.length = length;
      location.width = width;
      location.default_job_type = jobType || defaultCustomerJobType;
      location.new_beacon_id = beacon || null;
      location.id_parent = AppModel.newRoomForm.location['id_parent'];
      location.trimNumericFields();
      const { isValid, errorMessages } = this.isValid(location, namesList);
      return {
        line: i+1,
        location,
        isValid,
        errorMessages
      }
    })
    this.setState({ csvData: value })
  }

  insertNewRoom() {
    AppModelUtils.registerNewLocation()
    .then(()=> {
        // TODO : Should we take the user back ?
        // this.context.router.goBack();
    })
    .catch(()=> {
        console.log("insert was rejected, staying on page");
    });
  }

  insertMultipleRooms() {
    AppModelUtils.registerMultipleLocations(this.state.csvData, this.state.report)
    .then((res)=> {
      const data = res;
      const header = data.shift();
      const table = (
        <Table>
          <TableHeader
            displaySelectAll={false}
            adjustForCheckbox={false}
          >
            <TableRow>
              {header.map(d => (
                <TableHeaderColumn key={d}>{d}</TableHeaderColumn>
              ))}
            </TableRow>
          </TableHeader>
          <TableBody
            displayRowCheckbox={false}
          >
            {data.map((row, rowIndex) => (
            <TableRow key={rowIndex}>
                {row.map((d, columnIndex) => (
                    <TableRowColumn key={`${rowIndex}_${columnIndex}`}>{d}</TableRowColumn>
                ))}
            </TableRow>
            ))}
          </TableBody>
        </Table>
      )
      this.setState({ openDialog: true, csvResult: table });
    })
    .catch(()=> {
        console.log("insert was rejected, staying on page");
    });
  }

  cancelInsert() {
    AppModel.newRoomForm.reset();
    this.context.router.goBack();
  }

  resetInsertOperation() {
    // When server op failed and dialog box with error has been shown.
    AppModel.newRoomForm.serverOperation.reset();
  }

  render() {
    var form = AppModel.newRoomForm;
    var location = AppModel.newRoomForm.location;
    var volume_error_msg = location.volumeErrorMessage;
    var operation = AppModel.newRoomForm.serverOperation;
    var showFailDialog = ("FAIL"==operation.result);
    // If there are more than one job type for this customer, we will
    // allow the user to set a default job type for each location:
    var showJobTypeSelector = AppModel.availableJobTypes.length>1;

    // Helper function to decide if the Add button should be activated:
    const addButtonActive = () => {
      if(location.id_parent==null && !AppModel.allowAddingRootLocations) return false;
      if(!this.state.multiple && !this.state.uniqueName) return false;
      if(this.state.multiple && this.state.csvData && this.state.csvData.length > 0 && !this.state.csvData.some(data => !data.isValid)) return true;
      return location.isValid;
    }
    const actions = [
      <FlatButton
        label={uiMsg('OK',"OK")}
        primary={true}
        onTouchTap={this.resetInsertOperation} />,
    ];
    return (
      <PageLoading loading={operation.waiting
            || AppModel.fetchingLocationData
            || AppModel.fetchingLocationTypes }>
        <Dialog
          title={uiMsg('SERVER_FAILED',"Server operation failed")}
          actions={actions}
          modal={true}
          open={showFailDialog}>
          {operation.message}
        </Dialog>
        <div style={formStyle}>
          <SelectParentLocation target={location} />
          { // Only show the location type selector for users who can
            // create other types of locations than "rooms".
            AppModel.canEditLocations ?
            (<SelectRoomType target={location} />)
            : null
          }
          {location.id_type!='R' ? null : (
            <Checkbox
              label={uiMsg('NR_CREATE_MULTIPLE_ROOMS',"Create multiple rooms from CSV")}
              checked={this.state.multiple}
              onCheck={(e) => this.toggleCheck(e, 'multiple')}
            />
          )}
          { location.id_type==='R' && this.state.multiple ? (
            <span>
              <TextField
                floatingLabelText={uiMsg('NR_CREATE_MULTIPLE_ROOMS', "name,height,length,width,beacon,job_type - 1 room per line")}
                value={this.state.csv}
                onChange={this.handleCSV}
                multiLine
                fullWidth
                rows={4}
              />
              {this.state.csvData.some(data => !data.isValid) ?
                <span>
                  <p style={errorStyle}>Errors in line:</p>
                  {this.state.csvData.filter(data => !data.isValid).map(data => (
                    <p
                      key={data.line}
                      style={errorStyle}
                    >
                      {data.line}: {data.errorMessages.join(", ")}
                    </p>
                  ))}
                </span>
              : ""}
              <Checkbox
                label={uiMsg('NR_GENERATE_REPORT',"Generate report")}
                checked={this.state.report}
                onCheck={(e) => this.toggleCheck(e, 'report')}
              />
            </span>
          )
          : (
            <TextField  data-propname="name"
                        floatingLabelText={
                          location.isNameValid?
                            uiMsg('NR_NAME_PROMPT',"Name of <roomtype> ",location.typeName.toLowerCase())
                          : uiMsg('NR_NAME_PROMPT_REQ',"Name of <roomtype> Required",location.typeName.toLowerCase())
                          }
                        hintText={uiMsg('NR_NAME_PROMPT_HINT',"E.g. 104, A etc.")}
                        fullWidth={true}
                        value={location.name || ""}
                        onChange={(e) => {
                          this.handleValue(e);
                          this.uniqueName(location);
                        }}
                        errorText={this.state.uniqueName ?
                          null : uiMsg('NR_ROOM_NAME_NOT_AVAILABLE', "Room name is not available")
                        }
              />
            )}
          {location.id_type!='R' || this.state.multiple ? null : (<span>
             <TextField data-propname="height"
                        floatingLabelText={uiMsg('NR_HEIGHT',"Height in m" )}
                        hintText={uiMsg('NR_HEIGHT_HINT',"Height")}
                        value={location.height || ""}
                        onChange={this.handleValue}
                        fullWidth={true}
              />
             <TextField data-propname="length"
                        floatingLabelText={uiMsg('NR_LENGTH',"Length in m")}
                        hintText={uiMsg('NR_LENGTH_HINT',"Length")}
                        value={location.length || ""}
                        onChange={this.handleValue}
                        fullWidth={true}
              />
             <TextField data-propname="width"
                        floatingLabelText={uiMsg('NR_WIDTH',"Width in m")}
                        hintText={uiMsg('NR_WIDTH_HINT',"Width")}
                        value={location.width || ""}
                        onChange={this.handleValue}
                        fullWidth={true}
              />
             <TextField data-propname="volume_m3"
                        floatingLabelText={location.computedVolume ?
                          location.computedVolume.toFixed(2)+" m³" :
                          uiMsg('NR_VOLUME_M3',"Volume in m³")  }
                        hintText={uiMsg('NR_VOLUME_M3_HINT',"Volume, leave empty to use computed value")}
                        value={location.volume_m3 || ""}
                        onChange={this.handleValue}
                        fullWidth={true}
                        errorText={!!volume_error_msg ?
                          volume_error_msg : null}
              />
            <RegisterBeacon location={location} form={form} parent={this}/>

              {showJobTypeSelector ? <SelectDefaultJobType location={location} /> : null}
        </span>)}
        </div>
        <Toolbar>
          <ToolbarGroup firstChild={true}></ToolbarGroup>
          <ToolbarGroup lastChild={true}>
            <FlatButton
                    onTouchTap={this.cancelInsert.bind(this)}>
                    {form.isEmpty ? uiMsg('NR_B_CLOSE') : uiMsg('NR_B_CANCEL')}
            </FlatButton>
            <RaisedButton primary
                          disabled = {!addButtonActive()}
                          onTouchTap={this.state.multiple ? this.insertMultipleRooms.bind(this) : this.insertNewRoom.bind(this)}>
                          {this.state.multiple ? `${uiMsg('NR_B_ADD')} ${this.state.csvData.length || ""}` : uiMsg('NR_B_ADD')}
            </RaisedButton>
          </ToolbarGroup>
        </Toolbar>
        <Dialog
          title="CSV import results"
          modal={false}
          actions={[
            <FlatButton
              label={uiMsg('NR_B_CLOSE', "Close")}
              primary={true}
              keyboardFocused={true}
              onClick={this.handleClose}
            />
          ]}
          open={this.state.openDialog}
          onRequestClose={this.handleClose}
          autoScrollBodyContent={true}
          contentStyle={{ width: "80%", maxWidth: "2000px"}}
          bodyStyle={{ padding: 0, overflowX: "auto" }}
        >
          <div style={{minWidth: 1000}}>
            {this.state.csvResult}
          </div>
        </Dialog>
      </PageLoading>
    );
  }

};



/** WEBPACK FOOTER **
 ** ./src/pages/NewRoomPage.jsx
 **/